import { ChatAssistantResponse } from "../../models/responses/ChatAssistantResponse";
import * as types from "../actions/assistantActions";
import { ConversationCount } from "../actions/assistantActions";

interface AssistantState {
    userConversations: ChatAssistantResponse[];
    error: string | null;
}

const initialState: AssistantState = {
    userConversations: [],
    error: null,
};

export const assistantReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case types.CHAT_WITH_ASSISTANT_SUCCESS: {
            const currentLength = state.userConversations.length;
            const updatedConversations = [
                ...state.userConversations,
                {
                    Question: action.payload.Question,
                    Answer: action.payload.Answer,
                    ConversationId: action.payload.ConversationId,
                    OrderIndex: currentLength + 1,
                },
            ];

            return {
                ...state,
                userConversations: updatedConversations?.slice(-ConversationCount),
            };
        }
        case types.CHAT_WITH_ASSISTANT_ERROR:
        case types.LOAD_USER_CHAT_HISTORY_BY_SESSION_ID_SUCCESS:
            return {
                ...state,
                userConversations: action.payload,
            }
        case types.LOAD_USER_CHAT_HISTORY_BY_SESSION_ID_ERROR:
            return { ...state, error: action.payload }
        case types.CLEAR_USER_CONVERSATIONS:
            return {
                ...state,
                userConversations: [],
            }
        default:
            return state;
    }
}